import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { useActivation } from 'hooks/mobx-hooks'
import link from 'infra/link'
import UpcomingConsultationPreviewViewModel from './UpcomingConsultationPreviewViewModel'
import styles from './UpcomingConsultationPreview.sass'

interface UpcomingConsultationPreview {
  vm: UpcomingConsultationPreviewViewModel
}

export default observer(function UpcomingConsultationPreview({
  vm,
}: UpcomingConsultationPreview) {
  useActivation(vm)

  if (!vm.isPro || !vm.areConsultationsUpcoming) return

  const upcomingConsultations = vm.filteredConsultations
  const nextConsultation = upcomingConsultations[0]

  return (
    <div className={styles.root}>
      <div className={cx(styles.container, vm.isExpanded && styles.expanded)}>
        <div className={styles.row}>
          <div className={styles.text}>
            <h3 className={styles.title}>Upcoming calls</h3>
          </div>
          <div
            className={cx(styles.nextCallItem, vm.isExpanded && styles.hidden)}
          >
            <Icon
              className={styles.callItemIcon}
              color="var(--grey600)"
              name="call-video-on"
              size={32}
            />
            <div className={styles.callItemText}>
              <Button
                type="text"
                className={styles.nextCallItemButton}
                to={link.job(nextConsultation?.jobId ?? '')}
              >
                {nextConsultation?.clientDisplayName}
              </Button>
              <p className={styles.callItemDate}>
                {nextConsultation?.consultationStartDate}
              </p>
            </div>
          </div>
          <IconButton
            className={cx(
              styles.accordionButton,
              vm.isExpanded && styles.expanded,
            )}
            onClick={() => vm.toggleIsExpanded()}
            data-test="upcoming-consultation-preview-expand-toggle"
          >
            <Icon
              className={styles.accordionButtonIcon}
              color="var(--grey600)"
              name="arrow"
              size={24}
            />
          </IconButton>
        </div>
        <div
          className={cx(
            styles.row,
            styles.accordion,
            !vm.isExpanded && styles.hidden,
          )}
        >
          {upcomingConsultations.map((c, index) => (
            <div
              className={cx(styles.callItem, !vm.isExpanded && styles.hidden)}
              key={index}
            >
              <div className={styles.callItemText}>
                <h5 className={styles.callItemTitle}>{c.clientDisplayName}</h5>
                <p className={styles.callItemDate}>{c.consultationStartDate}</p>
              </div>
              <Button
                type="primary"
                className={styles.callItemButton}
                to={link.job(c.jobId)}
              >
                View Job
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})
